import { Dialog, DialogContent, DialogProps, DialogTitle } from '@mui/material';
import { FLAGGED_FEATURE } from '../../../common/constants/features';
import FeatureFlagMenuItem from '../feature-flag-menu-item/FeatureFlagMenuItem';

const FeatureFlagMenu = ({ open, onClose }: DialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Feature Flags</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {FLAGGED_FEATURE.map(feature => (
        <FeatureFlagMenuItem key={feature.key} feature={feature} />
      ))}
    </DialogContent>
  </Dialog>
);

export default FeatureFlagMenu;
